module.exports = __webpack_public_path__ + "img/taskNull.705e2988.png";